"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = sendAnswer;
async function sendAnswer({ leadSurveyId, responses, questionId }) {
    return fetch(`/api/surveys/leads/${leadSurveyId}/answer`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            questionId,
            responses
        })
    });
}
//# sourceMappingURL=sendAnswer.js.map